import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';

import { sendPhoneOtpThunk, verifyPhoneOtpThunk } from '../../core/store/actions/authActions';
import { PrivateRoutes } from '../../core/utils/constants';

import './Login.css';

const PLATFORMS = {
    TG: 'tg',
    MAX: 'max',
};

const RESEND_COOLDOWN_SECONDS = 30;

const ScreenLogin = () => {
    const { user, error } = useSelector((state) => state.auth);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [step, setStep] = useState('platform'); // 'platform' | 'phone' | 'code'
    const [platform, setPlatform] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [cooldown, setCooldown] = useState(0);
    const [pending, setPending] = useState(false);

    useEffect(() => {
        if (user) {
            navigate(PrivateRoutes.Reservation);
        }
    }, [ navigate, user ]);

    useEffect(() => {
        if (cooldown <= 0) return;
        const timer = setInterval(() => setCooldown((c) => c - 1), 1000);
        return () => clearInterval(timer);
    }, [cooldown]);

    const pickPlatform = useCallback((value) => {
        setPlatform(value);
        setStep('phone');
    }, []);

    const requestCode = useCallback(async (e) => {
        e.preventDefault();
        if (phoneNumber.length !== 10 || cooldown > 0 || pending) return;

        setPending(true);
        const result = await dispatch(sendPhoneOtpThunk({ phone_number: phoneNumber, platform }));
        setPending(false);

        if (sendPhoneOtpThunk.fulfilled.match(result)) {
            setCooldown(RESEND_COOLDOWN_SECONDS);
            setStep('code');
        }
    }, [dispatch, phoneNumber, platform, cooldown, pending]);

    const confirmCode = useCallback(async (e) => {
        e.preventDefault();
        if (otp.length === 0 || pending) return;

        setPending(true);
        await dispatch(verifyPhoneOtpThunk({ phone_number: phoneNumber, otp }));
        setPending(false);
    }, [dispatch, phoneNumber, otp, pending]);

    return (
        <div className='login-container'>
            <div className='login-composite-icon'>
                <img className='login-panda-icon' src='/img/icons/Panda.svg' alt='Panda' />
                <img className='login-team-it-icon' src='/img/icons/TeamIT.svg' alt='Team IT' />
            </div>

            <div className='login-panel'>
                {step === 'platform' && (
                    <div className='login-platform-picker'>
                        <span className='login-panel-span'>Куда прислать код для входа?</span>
                        <button type='button' className='login-platform-button' onClick={() => pickPlatform(PLATFORMS.TG)}>
                            Telegram
                        </button>
                        <button type='button' className='login-platform-button' onClick={() => pickPlatform(PLATFORMS.MAX)}>
                            MAX
                        </button>
                    </div>
                )}

                {step === 'phone' && (
                    <form className='login-phone-form' onSubmit={requestCode}>
                        <span className='login-panel-span'>Номер телефона (10 цифр, без кода страны)</span>
                        <input
                            type='tel'
                            inputMode='numeric'
                            className='login-input'
                            value={phoneNumber}
                            maxLength={10}
                            onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
                            placeholder='9991234567'
                            autoFocus
                        />
                        <button type='submit' className='login-platform-button' disabled={phoneNumber.length !== 10 || pending}>
                            Получить код
                        </button>
                        <button type='button' className='login-link-button' onClick={() => setStep('platform')}>
                            Назад
                        </button>
                    </form>
                )}

                {step === 'code' && (
                    <form className='login-phone-form' onSubmit={confirmCode}>
                        <span className='login-panel-span'>Код отправлен в {platform === PLATFORMS.TG ? 'Telegram' : 'MAX'}</span>
                        <input
                            type='text'
                            inputMode='numeric'
                            className='login-input'
                            value={otp}
                            onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                            placeholder='Код из сообщения'
                            autoFocus
                        />
                        <button type='submit' className='login-platform-button' disabled={otp.length === 0 || pending}>
                            Войти
                        </button>
                        <button
                            type='button'
                            className='login-link-button'
                            disabled={cooldown > 0 || pending}
                            onClick={requestCode}
                        >
                            {cooldown > 0 ? `Отправить код ещё раз (${cooldown}с)` : 'Отправить код ещё раз'}
                        </button>
                    </form>
                )}
            </div>

            {error && <div className='login-error'>{error}</div>}
        </div>
    );
}


export default ScreenLogin;
